import { render, staticRenderFns } from "./GalleryOption.vue?vue&type=template&id=72c0afcc&scoped=true"
import script from "./GalleryOption.vue?vue&type=script&lang=js"
export * from "./GalleryOption.vue?vue&type=script&lang=js"
import style0 from "./GalleryOption.vue?vue&type=style&index=0&id=72c0afcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c0afcc",
  null
  
)

export default component.exports